import React, { useState } from "react";
import { Box, Button, Typography, CircularProgress } from "@material-ui/core";
import { DropzoneArea } from "material-ui-dropzone";
import { toast } from "react-toastify";
import { useUpdateEdgePinchFilePost } from "../../../../common/services/fileServices";
import { useFetchContext } from "../../../../common/FetchContext";

export const EdgePinchRetestFileUpload = ({
  serialnumber,
  selectedFile,
  setSelectedFile,
  setTableData,
  setTableDatashow,
  onContinue,
}: any) => {
  const [loading, setLoading] = useState(false);
  const { mutateAsync: updateedgePinchFiles } = useUpdateEdgePinchFilePost();

  const { authAxios } = useFetchContext();

  const handleFileChange = (files: File[]) => {
    const file = files[0] || null;
    setSelectedFile(file);
  };

  const handleUpload = async () => {
    try {
      setLoading(true);

      const response = await updateedgePinchFiles({
        authAxios,
        selectedFile: selectedFile,
        serial_number: serialnumber,
      });

      setTableData(response.data);
      setTableDatashow(response);
      toast.success("File uploaded successfully");

      onContinue();
    } catch (err) {
      toast.error("Error while uploading file");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Typography variant="h6">Upload Edge Pinch Retest File</Typography>

      <Box mt={2}>
        <DropzoneArea
          acceptedFiles={[".xlsx", ".xls"]}
          dropzoneText="Drag and drop an Excel file here or click"
          filesLimit={1}
          onChange={handleFileChange}
          showAlerts={false}
        />
      </Box>

      {selectedFile && (
        <Box mt={2}>
          <Typography variant="body2" color="textSecondary">
            Selected File: {selectedFile.name}
          </Typography>
        </Box>
      )}

      <Box mt={3}>
        <Button
          variant="contained"
          color="primary"
          disabled={!selectedFile || loading}
          onClick={handleUpload}
        >
          {loading ? (
            <>
              <CircularProgress
                size={18}
                color="inherit"
                style={{ marginRight: 8 }}
              />
              Uploading...
            </>
          ) : (
            "Submit"
          )}
        </Button>
      </Box>
    </>
  );
};
